export const getClientDomainByUrl = (url) => {
  switch (url) {
    case 'https://www.easybet.net':
    case 'https://www.easybet.net/':
    case 'https://easybet.net':
    case 'https://easybet.net/':
      return 'easybet.net';
    case 'https://www.blueprint.com':
      return 'blueprint.com';
    case 'https://www.matchbook.com':
    case 'https://www.matchbook.com/':
    case 'https://matchbook.com':
    case 'https://matchbook.com/':
      return 'Matchbook.com';
    case 'https://www.matchbook.mx':
    case 'https://www.matchbook.mx/':
    case 'https://matchbook.mx':
    case 'https://matchbook.mx/':
      return 'Matchbook.mx';
    default:
      return null;
  }
};

export default getClientDomainByUrl;
